import { isEmail } from "../../utils/global.utils";

export const loginValidate = ({ email, password }) => {
  const errors = {};
  if (!email) {
    errors.email = "* Required";
  } else if (!isEmail(email)) {
    errors.email = "Invalid email";
  }

  if (!password) {
    errors.password = "* Required";
  }

  return errors;
};
